/**
 * หอหมึกสน (สำนักหอหมึกสน): scholarly and elegant, in a lilting three. The qin and zheng
 * converse like two scholars over tea, the xiao takes the second verse, harmonics in the third.
 */
import { arp, drone } from '../compose';
import { registerTrack } from '../registry';

const A_QIN = `@mf 1, 2,_ 3,_ 5, | 6,. 5,_ 3, | 2,_ 3,_ 5, 6,/ | 5,~-- |
  6, 1_ 2_ 3 | 2. 1_ 6, | 5,_ 6,_ 1 2, | 1,~--`;
const A_ZHENG = `@mp 0-- | 0- 5_ 6_ | 0-- | 0 1'_ 2'_ 3'~ | 0-- | 0- 3'_ 2'_\\ | 0-- | 1'g--`;
const ROOTS_A = `1, 6,, 2, 5,, 6,, 2, 5,, 1,`;

const B_XIAO = `@mf 3. 5_ 6 | 5_ 3_ 2- | 1_ 2_ 3 5 | 6-- ; | 1'. 6_ 5 | 3_ 5_ 6_ 5_ 3 | 2_ 3_ 1 6, | 1--`;
const B_QIN = `@mp 1,,-- | 5,,-- | 6,,-- | 2,-- | 1,-- | 3,-- | 2,-- | 1,,~--`;
const ROOTS_B = `1, 5,, 6,, 2, 1, 3, 2, 1,`;

const C_QIN = `@mp 6* 5* 3* | 2*-- | 3* 5* 6* | 1'*-- | 6*_ 5*_ 3* 2* | 1*-- | 2* 3* 5* | 6*--`;
const ROOTS_C = `6,, 2, 3, 6,, 2, 1, 5,, 6,,`;

registerTrack({
  id: 'pine-ink',
  order: 10,
  title: 'พู่กันกับหมึกในหอบัณฑิต',
  mood: 'สุภาพ สง่างาม ปัญญาชน',
  use: 'หอหมึกสน (สำนักหอหมึกสน)',
  key: 'Bb',
  mode: 'gong',
  bpm: 72,
  meter: 3,
  seed: 1010,
  parts: {
    qin: { inst: 'qin', pan: -0.15, reverb: 0.4 },
    zheng: { inst: 'zheng', gain: 0.85, pan: 0.2, reverb: 0.35 },
    harp: { inst: 'zheng', gain: 0.42, pan: 0.25, reverb: 0.35 },
    xiao: { inst: 'xiao', gain: 0.9, pan: -0.05, reverb: 0.45 },
    pad: { inst: 'pad', gain: 0.6, reverb: 0.45 },
    wood: { inst: 'perc', gain: 0.14, pan: 0.35, reverb: 0.4 },
  },
  sections: {
    A: {
      bars: 8,
      parts: {
        qin: A_QIN,
        zheng: A_ZHENG,
        pad: drone(ROOTS_A, 3),
        wood: `b-- | 0-- | 0-- | 0-- | 0-- | 0-- | 0-- | 0--`,
      },
    },
    B: {
      bars: 8,
      parts: {
        xiao: B_XIAO,
        qin: B_QIN,
        harp: arp(ROOTS_B, [0, 3, 5, 3, 5, 3]),
        pad: drone(ROOTS_B, 3),
      },
    },
    C: {
      bars: 8,
      parts: {
        qin: C_QIN,
        harp: arp(ROOTS_C, [0, null, 3, null, 5, null]),
        pad: drone(ROOTS_C, 3),
        wood: `b-- | 0-- | 0-- | 0-- | b-- | 0-- | 0-- | 0--`,
      },
    },
  },
  form: ['A', 'B', 'A', 'C', 'B'],
  loop: true,
});
